export const isAbortError = (error: unknown): boolean =>
  (error instanceof Error || error instanceof DOMException) &&
  error.name === 'AbortError';

export const createAbortError = (): DOMException =>
  new DOMException('Aborted', 'AbortError');
